<template>
  <div>
    <el-dialog
      title="Cambiar Responsable"
      :visible.sync="isVisible"
      width="25%"
      @close="OnResponsibleDialogClose"
      :destroy-on-close="true"
    >
      <el-form :model="form" class="justify-center" label-position="left">
        <el-row>
          <el-col :offset="1" :span="23">
            <el-form-item label="Nuevo Responsable:">
              <EmployeeSelector
                :CurrentEmployee="ActualEmployee"
                placeholder="Responsable"
                @selection-change="OnResponsibleSelected"
                :disabled="loadingData"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="OnResponsibleDialogClose">Cancel</el-button>
        <el-button type="primary" @click="OnSavingResponsible"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EmployeeSelector from "@/components/Company/EmployeeSelector";

export default {
  name: "EditResponsable",
  components: {
    EmployeeSelector
  },
  props: {
    ResponsibleDialogVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    ActualTaskInfo: {
      type: Object,
      default: () => ({}),
      required: false
    }
  },
  data() {
    return {
      // Define your data properties here
      formLabelWidth: 300,
      EmployeeSelected: 0
    };
  },
  computed: {
    // Define your computed properties here
    isVisible() {
      return this.ResponsibleDialogVisible;
    },
    ActualEmployee() {
      return this.ActualTaskInfo?.ResponsableID || null;
    }
  },
  methods: {
    // Define your methods here
    OnResponsibleDialogClose() {
      this.ActualEmployee = null;
      this.$emit("ResponsibleDialogClose");
    },
    OnResponsibleSelected(selectedEmployee) {
      console.log("Selected Employee:", selectedEmployee);
      this.EmployeeSelected = selectedEmployee || 0;
    },
    async OnSavingResponsible() {
      if (this.EmployeeSelected > 0) {
        this.$emit("SavingResponsible", this.EmployeeSelected);
        await this.$http
          .put("/api/ReporteGestion/ChangeResponsible", {
            Id: this.ActualTaskInfo.OriginalID,
            Task: this.ActualTaskInfo.ID,
            ResponsibleId: this.EmployeeSelected
          })
          .then(async () => {
            this.$emit("ResponsibleUpdated");
          });
      } else {
        this.$message.error("Debe seleccionar un responsable.");
      }
    }
  },
  watch: {
    ActualTaskInfo(val) {
      console.log("ActualTaskInfo changed:", val);
    }
  }
};
</script>

<style lang="scss" scoped></style>
